import Vue from 'vue';
import Vuex from 'vuex';
import venue from './venue';
import cart from './cart';
import brand from './brand';
import location from './location';
import discount from './discount';
import customer from './customer';
import deliveryAddress from './deliveryAddress';
import storeDesigner from './storeDesigner';
import giftCard from './giftCard';
import basket from './basket';
import bill from './bill';
import delivery from './delivery';
import helpers from './helpers';
import menu from './menu';
import marketing from './marketing';
import ably from './ably';
import VuexPersistence from 'vuex-persist';
import Cookies from 'js-cookie';

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'sk_takeaway',
    reducer: state => ({
        customer: {
            firstName: state.customer.firstName,
            lastName: state.customer.lastName,
            phone: state.customer.phone,
            email: state.customer.email,
            policyAgreed: state.customer.policyAgreed
        }
    })
});

const { hostname, pathname } = window.location;
const slug = pathname.split('/')[1];
const prefix = `sk_${hostname}_${slug || 'store'}`;
const cartKey = `${prefix}_cart`;
const billKey = `${prefix}_bill`;
const deliveryAddressKey = `${prefix}_delivery_address`;
const comoKey = `${prefix}_como`;
const allergenFiltersKey = `${prefix}_allergen`;

if (!Cookies.get(cartKey)) {
    localStorage.removeItem(cartKey);
}

if (!Cookies.get(billKey)) {
    localStorage.removeItem(billKey);
}

if (!Cookies.get(deliveryAddressKey)) {
    localStorage.removeItem(deliveryAddressKey);
}

if (!Cookies.get(allergenFiltersKey)) {
    localStorage.removeItem(allergenFiltersKey);
}

const cartStorage = new VuexPersistence({
    storage: window.localStorage,
    key: cartKey,
    saveState: (key, state, storage) => {
        Cookies.set(cartKey, 1, { expires: 1 / 288 });
        return storage.setItem(key, JSON.stringify(state));
    },
    reducer: state => ({
        cart: {
            items: state.cart.items,
            fulfillmentMethod: state.cart.fulfillmentMethod,
            totalWithDiscount: state.cart.totalWithDiscount,
            deliveryFee: state.cart.deliveryFee,
            selectedTip: state.cart.selectedTip,
            serviceCharge: state.cart.serviceCharge,
            piggyProductDiscount: state.cart.piggyProductDiscount,
            zoneDeliveryMinCost: state.cart.zoneDeliveryMinCost,
            piggyRewardSelected: state.cart.piggyRewardSelected,
            pickupDate: state.cart.pickupDate,
            pickupTimeSlot: state.cart.pickupTimeSlot,
            preOrderDateTime: state.cart.preOrderDateTime,
            ageOver18Confirmed: state.cart.ageOver18Confirmed,
            calculationMethod: state.cart.calculationMethod,
            noOfDiners: state.cart.noOfDiners,
            poNumber: state.cart.poNumber,
            zonalBasketId: state.cart.zonalBasketId,
            zonalDiscountSum: state.cart.zonalDiscountSum
        },
        discount: {
            details: state.discount.details
        },
        delivery: state.delivery
    })
});

const billStorage = new VuexPersistence({
    storage: window.localStorage,
    key: billKey,
    saveState: (key, state, storage) => {
        Cookies.set(billKey, 1, { expires: 1 / 144 });
        return storage.setItem(key, JSON.stringify(state));
    },
    reducer: state => ({
        bill: {
            id: state.bill.id
        }
    })
});

const deliveryAddressStorage = new VuexPersistence({
    storage: window.localStorage,
    key: deliveryAddressKey,
    saveState: (key, state, storage) => {
        Cookies.set(deliveryAddressKey, 1, { expires: 1 / 288 });
        return storage.setItem(key, JSON.stringify(state));
    },
    reducer: state => ({
        deliveryAddress: state.deliveryAddress
    })
});

const comoStorage = new VuexPersistence({
    storage: window.localStorage,
    key: comoKey,
    saveState: (key, state, storage) => {
        Cookies.set(comoKey, 1, { expires: 1 / 288 });
        return storage.setItem(key, JSON.stringify(state));
    },
    reducer: state => ({
        customer: {
            como: state.customer.como
        }
    })
});

const allergenFiltersStorage = new VuexPersistence({
    storage: window.localStorage,
    key: allergenFiltersKey,
    saveState: (key, state, storage) => {
        Cookies.set(allergenFiltersKey, 1, { expires: 1 / 288 });
        return storage.setItem(key, JSON.stringify(state));
    },
    reducer: state => ({
        helpers: {
            allergenFilters: state.helpers.allergenFilters,
            dietFilters: state.helpers.dietFilters
        }
    })
});

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        venue,
        cart,
        brand,
        location,
        discount,
        customer,
        deliveryAddress,
        storeDesigner,
        giftCard,
        basket,
        helpers,
        bill,
        delivery,
        menu,
        marketing,
        ably
    },
    plugins: [
        vuexLocal.plugin,
        comoStorage.plugin,
        cartStorage.plugin,
        billStorage.plugin,
        deliveryAddressStorage.plugin,
        allergenFiltersStorage.plugin
    ]
});

store.watch(
    state => state.cart.items,
    () => store.dispatch('ably/updateLiveCart'),
    { deep: true }
);

store.watch(
    state => [state.venue.venue.id, state.cart.selectedTableId],
    () => store.dispatch('ably/attach'),
    { immediate: true }
);

export default store;
